import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonComponent } from '../../feedback/button/button.component';
import { CmsTextProviderService } from '../../../services/cms-text-provider.service';
import { Dialog, IDialogData } from '../dialog';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
  selector: 'aw-font-reset-dialog',
  imports: [ButtonComponent, DialogComponent],
  templateUrl: './font-reset-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FontResetDialogComponent extends Dialog<IDialogData> {
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );
}
